<template>
  <el-form label-position="top">
   <el-row :gutter="guts">

    <el-col :span="12">
      <text-input label="Name" v-model="row.name" :disabled="disabled" />
    </el-col>

    <el-col :span="12">
      <number-input label="Users" :min="1" :max="10" v-model="row.users" :disabled="disabled" />
    </el-col>

    <h4>User Rates</h4>

    <el-row :gutter="guts">

      <el-col v-for="i in Number(row.users)" :key="i" :xs="24" :sm="12" :md="6" :lg="4">
        <number-input :label="'Rate #' + i" v-model="row['telco' + i]" suffix="%" :disabled="disabled" />
      </el-col>

    </el-row>

    <el-row :gutter="guts">
      <hr />
      <h4>Cabin &amp; Outdoor Rates</h4>
    </el-row>

    <el-row :gutter="guts">
      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <integer-input label="Cabin Qty."  v-model="row.cabin" :min="0" :max="10" :disabled="disabled" />
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <integer-input label="Cabin Rate"  v-model="row.cabinRate" :min="0" :max="100" suffix="%" :disabled="disabled" />
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <integer-input label="Outdoor Qty."  v-model="row.outdoor" :min="0" :max="10" :disabled="disabled" />
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="6">
        <integer-input label="Outdoor Rate" v-model="row.outdoorRate" :min="0" :max="100" suffix="%" :disabled="disabled" />
      </el-col>
    </el-row>

    <el-row :gutter="guts">
      <hr />
      <h4>MW &amp; RRU Rates</h4>
    </el-row>

    <el-col :span="8">
      <currency-input label="MW Rate" v-model="row.mwRate" :disabled="disabled" />
    </el-col>

    <el-col :span="8">
      <currency-input label="RRU Rate" v-model="row.rruRate" :disabled="disabled" />
    </el-col>

    <el-col :span="8">
      <number-input label="RRU Set" v-model="row.rruSet" :min="0" :max="10" :disabled="disabled" />
    </el-col>

 </el-row>

</el-form>

</template>



<script>

export default {

  props: {
    rowData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    }

  },

  watch: {
    editMode: function (val) {
      this.disabled = val
    }
  },

  data () {
    return {
      guts: 12,
      disabled: this.editMode,
      row: this.rowData ? this.rowData : this.getTableStruct('rates')
    }

  }

}
</script>
